import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import Button from 'layout/atoms/Button';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store';
import { selectLayout, setAddingProjectBottom } from 'store/layoutSlice';
import { selectWorkspaceData } from 'store/workspaceSlice';

export const AddProject = () => {
    const workspaceData = useSelector(selectWorkspaceData);
    const layoutState = useSelector(selectLayout);
    const dispatch: AppDispatch = useDispatch();

    const onAddNewProject = () => {
        dispatch(setAddingProjectBottom(true));
    };

    const addingDisabled =
        workspaceData.access.projectsLimit !== null &&
        workspaceData.access.projectsLimit <= workspaceData.projects.length;

    if (layoutState.projectAddingBottom) {
        return null;
    }

    return (
        <div>
            <Button
                size="l"
                theme="plain"
                onClick={onAddNewProject}
                disabled={addingDisabled}
            >
                <PlusIcon /> <p>New Project</p>
            </Button>
        </div>
    );
};
